import { defineAction } from '~/prix'
import citizenUpdateAction from './citizenUpdate.action.json' with { type: 'json' }
import { citizenObject } from '../citizenObject'
import { z } from 'zod'

const citizenUpdateDefinition = defineAction({
  ...citizenUpdateAction,

  input: citizenObject,
  output: z.object({}),
})

export default citizenUpdateDefinition
